var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('FormulateInput',{attrs:{"type":"date","name":_vm.fieldName,"placeholder":"yyyy-mm-dd","pattern":"\\d{4}-\\d{2}-\\d{2}","label":_vm.i18n.form.labels[_vm.fieldName],"help":_vm.helpText,"min":_vm.minDate,"max":_vm.maxDate || '9999-12-31',"validation":_vm.dateValidation,"validation-messages":_vm.validationMessages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }